import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { ApiRequestPost } from "../../../../data/network/services/ApiRequestPost";
import { fetchAllUserList } from "../../../../services/fetchListingData";
import secureStorage from "../../../../services/secureStorage";
import {
  colorDarkGreen,
  colorDarkRed,
  colorLightGreen,
  colorLightRed,
} from "../../../../utility/constants/colorManager";
import { SS_ROLE } from "../../../../utility/constants/secureStorageManager";
import {
  ADMIN,
  ADMIN_USER,
  RUPEES_SYMBOL,
  STATUS_CODE_200,
} from "../../../../utility/constants/valueConstants";
import { formatBalance } from "../../../../utility/moneyFormatter";
import ResizeListner from "../../../../utility/ResizeListner";
import { OnBoadingClientHeaders } from "../../../../utility/TableHeaders";
import CustomTable from "../../../components/main_comps/custom_table";

const tabs = [
  { name: "Active Clients", key: 0 },
  { name: "Inactive Clients", key: 1 },
];
const CountsContainer = ({ backgroundColor, color, title, count, style }) => {
  return (
    <div
      style={{
        margin: 10,
        backgroundColor,
        display: "flex",
        padding: "12px 20px",
        justifyContent: "space-evenly",
        alignItems: "center",
        borderRadius: 5,
        minWidth: 140,
        ...style,
      }}
    >
      <p
        style={{
          color,
          marginRight: 20,
          fontWeight: "600",
          fontSize: 12,
        }}
      >
        {title}
      </p>

      <p
        style={{
          color,
          marginRight: 20,
          fontWeight: "600",
          fontSize: 12,
        }}
      >
        {count}
      </p>
    </div>
  );
};
function OnboardedClients({ userRefId, data }) {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const { width, height } = ResizeListner();
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(0);
  const [onBoardedClientData, setOnBoardedClientData] = useState([]);
  const [countData, setCountData] = useState({});
  const role = secureStorage.getItem(SS_ROLE);

  const getClientCount = () => {
    ApiRequestPost.fetchClientCount({
      rootReferenceId:
        data?.role.toUpperCase() === ADMIN ||
        data?.role.toUpperCase() === ADMIN_USER
          ? ""
          : userRefId,
    })
      .then((res) => {
        if (res.statusCode === STATUS_CODE_200) {
          setCountData(res.data);
        }
      })
      .catch((err) => {
        enqueueSnackbar(err.message, {
          variant: "error",
        });
      });
  };

  const getOnBoardedClient = (page, size) => {
    ApiRequestPost.fetchClientList({
      rootReferenceId:
        data?.role.toUpperCase() === ADMIN ||
        data?.role.toUpperCase() === ADMIN_USER
          ? ""
          : userRefId,
      page,
      size,
      activeStatus: "",
    })
      .then((res) => {
        if (res.statusCode === STATUS_CODE_200) {
          setOnBoardedClientData(res.data);
        }
      })
      .catch((err) => {
        enqueueSnackbar(err.message, {
          variant: "error",
        });
      });
  };
  useEffect(() => {
    getOnBoardedClient(0, 10);
    getClientCount();
  }, []);

  return (
    <div>
      <div
        style={{
          width: "100%",
          display: "flex",
          borderBottom: "1px solid #f3f3f3",
          margin: "10px 0px",
        }}
      >
        <CountsContainer
          backgroundColor={colorLightGreen}
          color={colorDarkGreen}
          title="Active Clients"
          count={countData?.activeCount}
        />
        <CountsContainer
          backgroundColor={colorLightRed}
          color={colorDarkRed}
          title="Inactive Clients"
          count={countData?.inactiveCount}
        />
      </div>
      <div style={{ padding: "0px 20px", overflow: "hidden" }}>
        <CustomTable
          styles={{
            maxHeight: height * 0.7,
            minHeight: height * 0.7,
          }}
          data={onBoardedClientData.clients}
          headers={OnBoadingClientHeaders}
          totalElements={onBoardedClientData.totalRecords}
          totalPages={onBoardedClientData.totalPages}
          handlePaginate={(page) => {
            getOnBoardedClient(page + 1, 10);
          }}
          currentPage={onBoardedClientData?.currentPageNo - 1}
        />
      </div>
    </div>
  );
}

export default OnboardedClients;
